import { render, staticRenderFns } from "./TakipBorcluPicker.vue?vue&type=template&id=0fefbda1"
import script from "./TakipBorcluPicker.vue?vue&type=script&lang=ts"
export * from "./TakipBorcluPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports